const onboardingKnowledgeCenterList = [
  {
    MetricName: 'Metric Definitions',
    MetricText: 'Look up definitions of metrics through search or read through the full glossary.',
    MetricLink: 1,
  },
  {
    MetricName: 'User Guide',
    MetricText:
      "A detailed guidebook for a deeper understanding of Insight's information and capabilities.",
    MetricLink: 4,
  },
  {
    MetricName: 'Features Guide',
    MetricText: 'A resource for navigating and understanding the basics of Insights. ',
    MetricLink: 2,
  },
  {
    MetricName: 'Read Release Notes',
    MetricText: 'Full details, improvements, and fixes (~5 min read)',
    MetricLink: 3,
  },
];

const APP_CONSTANT = {
  themeOverride: {
    deprecatedFont: false,
  },
  includeBaseCss: false,
  ONBOARDING_KC_LIST: onboardingKnowledgeCenterList,
};
export default APP_CONSTANT;
